import { createRoot } from "react-dom/client";
import App from "./App/App.js";
import { StrictMode } from "react";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// TEst
